export default __webpack_public_path__ + "static/media/red1.a8eb55e8.svg";